<template lang="pug">
v-container.pa-8
  div.main-container.mb-5
    v-row(no-gutters)
      v-col(cols="12" sm="3")
        v-tabs(v-model="userTab" color="neutral700" :height="44" grow)
          v-tab.text-lg.font-medium.text-capitalize {{ $t('roles') }}
          v-tab.text-lg.font-medium.text-capitalize {{ $t('user_log') }}
    div.separator(:style="{ 'background-color':$vuetify.theme.themes[$theme].basic600T16 }")

  v-tabs-items(v-model="userTab" touchless)
    v-tab-item
      user-roles
    v-tab-item
      user-log

</template>

<script>
import UserRoles from '@/components/clinic/usersettings/UserRoles.vue'
import UserLog from '@/components/clinic/usersettings/UserLog.vue'

export default {
  name: 'ClinicUserSettings',
  components: { UserRoles, UserLog },
  data () {
    return {
      userTab: 0
    }
  }
}
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
.main-container {
  position: relative;
}
.separator {
  position: absolute;
  height:3px;
  top: 42px;
  left: 0px;
  right: 0px;
}
</style>